import { render, staticRenderFns } from "./CorreoPaciente.vue?vue&type=template&id=1cdfc63c&scoped=true"
import script from "./CorreoPaciente.vue?vue&type=script&lang=js"
export * from "./CorreoPaciente.vue?vue&type=script&lang=js"
import style0 from "./CorreoPaciente.vue?vue&type=style&index=0&id=1cdfc63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfc63c",
  null
  
)

export default component.exports